import styled from '@emotion/styled';
import { colors, getTypographyCss, theme } from '@revenuemarket/design';

// TODO: Refactor to resolve circular dependency
// oxlint-disable-next-line import/no-cycle
import { CheckboxProps } from './Checkbox';

export const Wrapper = styled.div`
  display: flex;
  position: relative;
  min-height: 20px;
`;

export const Input = styled.input`
  clip: rect(0, 0, 0, 0);
  border: 0;
  height: 1px;
  left: 0.7rem;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  top: 1.25rem;
  visibility: inherit;
  white-space: nowrap;
  width: 1px;
`;

export const Label = styled.label<Pick<CheckboxProps, 'label' | 'disabled'>>`
  display: flex;
  align-items: center;
  cursor: pointer;
  min-height: 1.5rem;
  padding-left: ${({ label }) => (label ? '21px' : '16px')};
  position: relative;
  user-select: none;
  color: ${theme.colors.grayscale400};
  ${getTypographyCss('body1')};

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 5px;
    left: 0;
    box-sizing: border-box;
  }

  &::before {
    width: 15px;
    height: 15px;
    border: 2px solid ${theme.colors.grayscale400};
    border-radius: 4px;
  }

  &::after {
    display: block;
    background: none;
    border-bottom: 2px solid white;
    border-left: 2px solid white;
    width: 10px;
    height: 6px;
    top: 4px;
    left: 3px;
    transform: scale(0) rotate(-45deg);
    transform-origin: bottom right;
  }

  input:checked + & {
    color: ${theme.colors.grayscaleWhite};
    &::before {
      border-color: ${theme.colors.teal1000};
      background: ${theme.colors.teal1000};
    }

    ${({ disabled }) =>
      disabled &&
      `color: ${colors.grayscale400};
      &::before {
        border-color: ${colors.grayscale450};
        background: ${colors.grayscale450};
      }
`}

    &::after {
      transform: scale(1) rotate(-45deg);
    }
  }
`;
